import { useState,useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    document.title = "Contact Us | Yappyli";
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setStatus({ type: 'error', message: 'Please complete the CAPTCHA.' });
      return;
    }
    setLoading(true);
    try {
      // Replace with your actual backend endpoint
      const response = await fetch('/contact-form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, recaptchaToken })
      });
      const data = await response.json();
      if (data.success) {
        setStatus({ type: 'success', message: '✓ Message sent successfully! We’ll get back to you soon.' });
        setFormData({ name: '', email: '', subject: '', message: '' });
        setRecaptchaToken(null);
      } else {
        throw new Error(data.error || 'Failed to send');
      }
    } catch (err) {
      setStatus({ type: 'error', message: err.message || 'Failed to send. Please try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="pt-32 pb-20 px-6 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/2">
          <span className="bg-[#EEECFF] text-[#7367ff] px-4 py-1 rounded-full font-bold text-xs uppercase tracking-widest">Get in Touch</span>
          <h1 className="text-5xl font-extrabold text-[#0F172A] mt-6 mb-8">Let's <span className="italic underline decoration-[#7367ff] underline-offset-4">Yap.</span></h1>
          <p className="text-xl text-[#64748B] mb-8 leading-relaxed">
            Have a question, a bug report, or just want to say hi? We're a small team, but we read every message that comes through.
          </p>
          
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#FAFAFC] rounded-xl flex items-center justify-center text-[#0F172A] border border-[#EEECFF]">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <h4 className="font-bold text-[#0F172A]">Email Us</h4>
                <p className="text-sm text-[#64748B]">hello@yappyli.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#FAFAFC] rounded-xl flex items-center justify-center text-[#0F172A] border border-[#EEECFF]">
                <i className="fab fa-github"></i>
              </div>
              <div>
                <h4 className="font-bold text-[#0F172A]">Open Source</h4>
                <p className="text-sm text-[#64748B]">github.com/yappyli/app</p>
              </div>
            </div>
          </div>
        </div>

        <div className="md:w-1/2 bg-[#FAFAFC] p-8 md:p-12 rounded-3xl border border-[#EEECFF]">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="block text-xs font-extrabold text-[#0F172A] uppercase tracking-widest mb-2">Name</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" className="w-full px-4 py-3 rounded-xl bg-white border border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#7367ff]/40" required />
              </div>
              <div>
                <label className="block text-xs font-extrabold text-[#0F172A] uppercase tracking-widest mb-2">Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" className="w-full px-4 py-3 rounded-xl bg-white border border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#7367ff]/40" required />
              </div>
            </div>
            <div>
              <label className="block text-xs font-extrabold text-[#0F172A] uppercase tracking-widest mb-2">Subject</label>
              <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="What's on your mind?" className="w-full px-4 py-3 rounded-xl bg-white border border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#7367ff]/40" required />
            </div>
            <div>
              <label className="block text-xs font-extrabold text-[#0F172A] uppercase tracking-widest mb-2">Message</label>
              <textarea name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Start yapping..." className="w-full px-4 py-3 rounded-xl bg-white border border-[#E2E8F0] focus:outline-none focus:ring-2 focus:ring-[#7367ff]/40" required></textarea>
            </div>

            <ReCAPTCHA
              sitekey="6LfD87YsAAAAAIQKfqH5eK_JHf7nowo4PO-L2EUU"
              onChange={(token) => setRecaptchaToken(token)}
            />

            <button type="submit" disabled={loading} className="w-full bg-[#7367ff] text-white font-bold py-4 rounded-xl shadow-[0_10px_20px_rgba(115,103,255,0.3)] hover:bg-[#5d4eff] hover:-translate-y-0.5 uppercase tracking-widest text-sm disabled:opacity-50">
              {loading ? 'Sending...' : 'Send Message'}
            </button>
            {status.message && (
              <div className={`text-center text-sm p-3 rounded-lg ${status.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                {status.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}